export default {
  env: 'development',
  assetsEndpoint: 'https://static.dev.mdirector.com/assets/',
  storage: {
    domain: 'https://app.dev.mdirector.com',
    file: '/storage.php',
  },
  services: {
    email_marketing: { frontUrl: 'https://app.dev.mdirector.com' },
    email_transactional: { frontUrl: 'https://trans.dev.mdirector.com' },
    marketing_automation: { frontUrl: 'https://automation.dev.mdirector.com' },
    landing_optimizer: { frontUrl: 'https://landings.dev.mdirector.com' },
    payments: { frontUrl: 'https://payments.dev.mdirector.com' },
    integrations: {
      frontUrl: 'https://signup.dev.mdirector.com',
      zapier: true,
      shopify: true,
      apis: true,
    },
  },
};
